export const ADD_IMAGE = "ADD_IMAGE"